import { all, fork } from 'redux-saga/effects';
import registerSaga from './register';
import loginSaga from './login';
import adminLoginSaga from './admin-login';

import forgotPasswordSaga from './forgotPassword';
import jobsSaga from './jobs';
import adminDashboardSaga from './adminDashboard';
import proposalSaga from './proposal';
import profileSaga from './profile/coder.sagas';
import coderRegistration from './coderRegistration';
import timezoneSaga from './timezone';
import recommendedTechSaga from './recommendedTech';
import educationForm from './educationForm';
import recommendedCoderSaga from './recommended/coder.saga';
import resetPasswordSaga from './resetPassword';
import companyDetailSaga from './companyDetail';
import clientProfileSaga from './clientProfile';
import technologiesSaga from './technologies';
import cordersSaga from './coders';
import recommendedJobSaga from './recommendedJobs';
import TnCSaga from './tnc';
import timesheetSaga from './timesheet';
import contractSaga from './contract';
import userInfoSaga from './userInfo';
import adminSaga from './admin';
import coder from './coder';

import skillAndExperienceSaga from './skillsAndExperience';
import payemnetStatusSaga from './payment/payment.saga';
import recommendedHomeJobsSaga from './recommended/jobs.saga';
import postContactSupportSaga from './contact/contact.saga';
import countryListSaga from './countryList';
import stripPaymentSaga from './stripPaymentSaga';
import chatSaga from './chat/chat.saga';
import paymentSaga from './payment.saga';
import notificationSaga from './notification/notification.saga';
import reportSaga from './report/report.saga';

export function* rootSaga() {
  yield all([
    fork(registerSaga),
    fork(loginSaga),
    fork(adminLoginSaga),
    fork(forgotPasswordSaga),
    fork(jobsSaga),
    fork(contractSaga),
    fork(companyDetailSaga),
    fork(timesheetSaga),
    fork(TnCSaga),
    fork(adminSaga),
    fork(clientProfileSaga),
    fork(proposalSaga),
    fork(educationForm),
    fork(recommendedCoderSaga),
    fork(profileSaga),
    fork(resetPasswordSaga),
    fork(coderRegistration),
    fork(timezoneSaga),
    fork(recommendedTechSaga),
    fork(technologiesSaga),
    fork(cordersSaga),
    fork(recommendedJobSaga),
    fork(adminDashboardSaga),
    fork(userInfoSaga),
    fork(skillAndExperienceSaga),
    fork(coder),
    fork(payemnetStatusSaga),
    fork(recommendedHomeJobsSaga),
    fork(postContactSupportSaga),
    fork(countryListSaga),
    fork(stripPaymentSaga),
    fork(paymentSaga),
    fork(chatSaga),
    fork(notificationSaga),
    fork(reportSaga)
  ]);
}
